<template lang="pug">
    div
        BreadCrumb(:linkBreadCrumb='linkBreadCrumb')
        manager-wholesale-discounts(
            submitText="Actualizar"
            crudOption="show-edit"
            optionType="family"
            @clear-form="clearForm"
            @submit-form="submitForm"
            @return-previous-route="returnPreviousRoute"
            @cancel-editing="restartEditing"
            @delete="confirmDelete"
            )
            div
                family-data

</template>

<script>
import { BreadCrumb } from '@/components/reusable_components'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import ManagerWholesaleDiscounts from '@/components/WholesaleDiscount/Manager'
import SnackbarModalUtils from '@/mixins/SnackbarModalUtils'
import { DELETE_WHOLESALE_DISCOUNT } from '@/components/SnackbarModal/SnackbarActions'

import FamilyData from './FamilyData'

import FamilyWholesaleDiscountService from '@/services/api/family/FamilyWholesaleDiscountService'
import { mapActions, mapState } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: false,
                    to: `/families`,
                    exact: true,
                },
                {
                    text: 'Familia',
                    disabled: false,
                    to: `/families/${this.$route.params.id}`,
                    exact: true,
                },
                {
                    text: 'Edición Esquema Descuentos',
                    disabled: true,
                },
            ],
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
            globalPercentageDiscount: 'globalPercentageDiscount',
        }),
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        ...mapActions('WholesaleDiscountModule', {
            resetArrayDiscounts: 'resetArrayDiscounts',
            setInitialArrayDiscounts: 'setInitialArrayDiscounts',
            restartEditingWholesaleDiscount: 'restartEditing',
            setGlobalPercentageDiscount: 'setGlobalPercentageDiscount',
            resetStateWholesaleDiscount: 'resetState',
            setId: 'setId',
            setMaxPriceDiscount: 'setMaxPriceDiscount',
            restartEditing :'restartEditing',
        }),

        restartEditing() {
            this.restartEditingWholesaleDiscount()
        },

        confirmDelete() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack(DELETE_WHOLESALE_DISCOUNT)
            let payload = this.fillSnack(
                'warning',
                '¿Desea eliminar esquema de descuentos?',
                'Si actualiza, se borrarán todos los esquemas existentes'
            )
            this.initSnackbar(payload)
            // this.itemDeleteId = event
            // console.log(event)
        },

        clearForm() {
            //this.restartEditing()
            this.resetArrayDiscounts()
        },

        async submitForm() {
            let snackLoading = this.fillSnack(
                'info',
                'Actualizando esquema',
                'Espere un momento',
                true,
                6000
            )
            this.initSnackbar(snackLoading)
            let response = await FamilyWholesaleDiscountService.updateWholesaleDiscounts(
                this.arrayDiscounts,
                this.id
            )
            if (response.status == 'success') {
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'El esquema de descuentos se ha actualizado exitosamente',
                    false,
                    6000
                )
                this.initSnackbar(snackInfo)
                this.returnPreviousRoute()
            } else {
                //TODO: test response error from backend
                let snackInfo = this.fillSnack(
                    'error',
                    'Error',
                    response,
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
            }
        },

        returnPreviousRoute() {
            this.$router.push({ path: `/families/${this.id}` })
        },
    },
    watch: {
        async responseConfirm(val) {
            if (val == DELETE_WHOLESALE_DISCOUNT) {
                let response = await FamilyWholesaleDiscountService.deleteWholesaleDiscounts(
                    this.id
                )
                if (response.status == 'success') {
                    this.resetSnackbarState()
                    let payload = this.fillSnack(
                        'success',
                        'Esquema de descuentos eliminado',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.returnPreviousRoute()
                } else {
                    this.resetSnackbarState()
                    let payload = this.fillSnack('error', 'Error', response)
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: { ManagerWholesaleDiscounts, FamilyData, BreadCrumb },
    mixins: [InputValidations, CurrencyUtils, SnackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},

    // // TODO
    beforeMount: async function() {
        let id = this.$route.params.id
        let whDiscounts = await FamilyWholesaleDiscountService.fetchWholesaleDiscountsFamily(
            id
        )
        if (whDiscounts === null || whDiscounts.length === 0) {
            // Wholesale discounts should be created
            this.$router.push({
                path: `/families/${id}/wholesale_discounts/create`,
            })
        } else {
            // Wholesale discounts should be shown/edited
            await this.resetStateWholesaleDiscount()
            this.setId(id)
            this.setGlobalPercentageDiscount(true)
            this.setInitialArrayDiscounts(whDiscounts)
            this.setMaxPriceDiscount(100)
        }
    },
    mounted: function() {
        this.setTitleTopBar('Editar esquema descuentos familia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_WHOLESALE_DISCOUNT_BY_FAMILY'))
                ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>